import { Custom } from "components";
import { useApp } from "context";
import { useForm } from "hooks";
import { useNavigate } from "react-router-dom";
import { Enums, Routes } from "utils";

export const ForgotPassword = (props: any) => {
  const { t, setFeedback, service } = useApp();
  const navigate = useNavigate();

  const initialState = {
    email: "",
  };

  const { onChange, onSubmit, values } = useForm(submitCallback, initialState);

  async function submitCallback() {
    const { email }: any = values;
    const [status, response] = await service.auth.forgotPassword(email);
    if (status === Enums.EnumResponse.Success) {
      setFeedback({
        message: t.message.auth.email_sent,
        severity: Enums.EnumFeedback.Info,
      });
      navigate(Routes.auth.signin);
    } else if (status === Enums.EnumResponse.NotFound) {
      setFeedback({
        message: t.message.auth.email_not_found,
        severity: Enums.EnumFeedback.Error,
      });
    } else {
      setFeedback({
        message: t.message.feedback.request_error,
        severity: Enums.EnumFeedback.Error,
      });
    }
  }

  return (
    <form onSubmit={onSubmit} className="qh-form">
      <Custom.TextField
        name="email"
        required={true}
        label={t.label.email}
        onChange={onChange}
      />
      <div className="qh-control">
        <Custom.Button submit>{t.action.send_email}</Custom.Button>
      </div>
    </form>
  );
};
